<script setup lang="ts">
import './container.css';

interface PhxsgContainerProps {
  size?: '2xs' | 'xs' | 'sm' | 'md';
  use?: keyof HTMLElementTagNameMap;
}

const { use = 'div' } = defineProps<PhxsgContainerProps>();
</script>

<template>
  <component
    :is="use"
    :class="[
      'phxsg-container',
      {
        [`phxsg-container--${size}`]: size,
      },
    ]"
  >
    <slot />
  </component>
</template>
